import { Card, Col, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import InputField from '../../../../components/fields/InputField';
import PasswordField from '../../../../components/fields/PasswordField';

const StyledContainer = styled(Row)`
    background-color: #fff;
    padding: 20px;
`;

const CapModuleMainDetailsForm = () => {
    const { t } = useTranslation(['capModuleDetails']);

    return (
        <StyledContainer gutter={10}>
            <Space direction="vertical" style={{ width: '100%' }}>
                <Col span={24}>
                    <Card title={t('capModuleDetails:sections.porscheDetails')}>
                        <Row gutter={16}>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.baseUrl', { returnObjects: true })}
                                    name="capSetting.capBaseUrl"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.region', { returnObjects: true })}
                                    name="capSetting.capRegion"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.group', { returnObjects: true })}
                                    name="capSetting.capGroup"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.endpointEnv', { returnObjects: true })}
                                    name="capSetting.capEndpointEnv"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.clientId', { returnObjects: true })}
                                    name="capSetting.clientId"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <PasswordField
                                    {...t('capModuleDetails:fields.clientSecret', { returnObjects: true })}
                                    name="capSetting.clientSecret"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.authGroup', { returnObjects: true })}
                                    name="capSetting.capAuthGroup"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.pagImporterId', { returnObjects: true })}
                                    name="capSetting.capPagImporterId"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.language', { returnObjects: true })}
                                    name="capSetting.capLanguage"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.dataOrigin', { returnObjects: true })}
                                    name="capSetting.capSource"
                                />
                            </Col>
                        </Row>
                    </Card>
                </Col>

                <Col span={24}>
                    <Card title={t('capModuleDetails:sections.ppnDetails')}>
                        <Row gutter={16}>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.app2appHost', { returnObjects: true })}
                                    name="capSetting.app2appHost"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.app2appResource', { returnObjects: true })}
                                    name="capSetting.app2appResource"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <InputField
                                    {...t('capModuleDetails:fields.app2appClient', { returnObjects: true })}
                                    name="capSetting.app2appClient"
                                />
                            </Col>
                            <Col lg={12} xs={24}>
                                <PasswordField
                                    {...t('capModuleDetails:fields.app2appSecret', { returnObjects: true })}
                                    name="capSetting.app2appSecret"
                                />
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Space>
        </StyledContainer>
    );
};

export default CapModuleMainDetailsForm;
